import { useMemo, useState } from 'react';

/**
 * Paginación 100% cliente (HU-012) — para las pantallas que traen toda la
 * lista de una sola llamada (Usuarios, Roles, Vías, Categorías) y no tienen
 * paginado real del backend, a diferencia de Tickets (que sí es server-side
 * y arma su propio objeto `paginacion`). Devuelve la porción de `items` que
 * corresponde a la página actual + el mismo objeto `paginacion` que ya
 * espera `DataTable` (`page`/`pageSize`/`total`/`pageSizeEfectivo`/
 * `onPageChange`/`onPageSizeChange`), así el componente no distingue entre
 * paginado local o remoto.
 */
const usePaginacionLocal = (items, pageSizeInicial = 10) => {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(pageSizeInicial);

  const total = items.length;
  const pageSizeEfectivo = pageSize === 'todos' ? Math.max(total, 1) : pageSize;
  // Si un filtro/búsqueda redujo la lista y la página actual quedó fuera de
  // rango, se muestra la última página válida en vez de una pantalla vacía.
  const totalPaginas = pageSize === 'todos' ? 1 : Math.max(1, Math.ceil(total / pageSize));
  const paginaSegura = Math.min(page, totalPaginas);

  const datosPagina = useMemo(() => {
    if (pageSize === 'todos') return items;
    const inicio = (paginaSegura - 1) * pageSize;
    return items.slice(inicio, inicio + pageSize);
  }, [items, paginaSegura, pageSize]);

  const cambiarPageSize = (nuevo) => { setPageSize(nuevo); setPage(1); };

  return {
    datosPagina,
    paginacion: {
      page: paginaSegura,
      pageSize,
      pageSizeEfectivo,
      total,
      onPageChange: setPage,
      onPageSizeChange: cambiarPageSize,
    },
  };
};

export default usePaginacionLocal;
